import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import DropdownMenuNavigations from '../dropdownmenunavigations';
import KampLogo from '../../assets/logo/logo.jpg';

const MobileMenuDropdown = ({ isOpen, setIsOpen }) => {
  const inactiveStr = classNames(
    'flex items-center justify-start bg-transparent p-2.5 text-base font-medium rounded-lg no-underline hover:bg-[hsl(221,13%,30%)] group',
  );
  const activeStr = classNames(
    'flex items-center justify-start bg-[hsl(221,13%,45%)] p-2.5 text-base font-medium rounded-lg no-underline group',
  );
  return (
    <>
      <div className="flex items-center justify-between px-6 py-3 bg-white">
        <Link to="/dashboard" className="flex items-center">
          <img src={KampLogo} className="h-10 mr-3" alt="Kamp Logo" />
        </Link>
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex items-center justify-center w-8 h-8 text-sm text-gray-900 bg-transparent rounded-lg hover:bg-gray-200 ms-auto"
        >
          <svg
            className="w-4 h-4"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <ul className="p-4 space-y-4">
        {DropdownMenuNavigations.map(({ link, icon, label }, index) => {
          return (
            <li key={index}>
              <NavLink
                to={link}
                end
                onClick={() => setIsOpen(!isOpen)}
                className={({ isActive }) =>
                  isActive ? activeStr : inactiveStr
                }
              >
                {icon}
                <span className="ml-3 text-white">{label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </>
  );
};

MobileMenuDropdown.defaultProps = {
  isOpen: false,
  setIsOpen: null,
};

MobileMenuDropdown.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export default MobileMenuDropdown;
